import LogoutContent from '../components/logout/LogoutContent';
import LogoutHead from '../components/logout/LogoutHead';

export default function Logout() {
  return (
    <>
      <LogoutHead />
      <LogoutContent />
    </>
  );
}